const analyticalProducts = [
  {
    
  id: 1,
  name: "pH Analyzer",
  description: "Online continuous pH measurement.",
  image: "/assets/sensors/ph.png",
  pdf: "/assets/pdf/ph.pdf",
  price: "Request Quote"
},
  {
    id: 2,
    name: "Conductivity Meter",
    description: "High-accuracy conductivity & TDS monitoring.",
    image: "/assets/sensors/CM.png",
    pdf: "/assets/pdf/conductivity-datasheet.pdf",
    price: "Request Quote"
  },
  {
    id: 3,
    name: "Dissolved Oxygen (DO)",
    description: "Optical or galvanic DO probes for wastewater & process.",
    image: "/assets/sensors/DO.png",
    pdf: "/assets/pdf/do-datasheet.pdf",
    price: "Request Quote"
  },
  {
    id: 4,
    name: "Turbidity Meter",
    description: "Nephelometric turbidity measurement for clarity control.",
    image: "/assets/sensors/TB.png",
    pdf: "/assets/pdf/turbidity-datasheet.pdf",
    price: "Request Quote"
  },
  {
    id: 5,
    name: "Chlorine Analyzer",
    description: "Free & total chlorine monitoring for potable water.",
    image: "/assets/sensors/cl.png",
    pdf: "/assets/pdf/chlorine-datasheet.pdf",
    price: "Request Quote"
  },
  {
    id: 6,
    name: "TOC Analyzer",
    description: "Total organic carbon monitoring for process & effluent.",
    image: "/assets/sensors/toc.png",
    pdf: "/assets/pdf/toc-datasheet.pdf",
    price: "Request Quote"
  }
];

export default analyticalProducts;
